import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./maintenance-mode-config.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./maintenance-mode-config.scss?ngResource";
import { Component, ChangeDetectorRef } from "@angular/core";
import { AppControllerService } from "../../app-controller.service";
import { AutoUnsub } from "../../shared/decorators/autounsub.decorator";
import { MaintenanceModeConfigConstants } from "./maintenance-mode-config.constants";
import { UserInformationService } from "../../shared/services/user/user-information.service";
import { AlertType } from "../../shared/models/alert";
import { AppRoutingConstants } from "../../app-routing.constants";
import { DashboardRoutingConstants } from "../dashboard/dashboard-routing.constants";
import { SystemSettingService } from "../../shared/services/system-setting/system-setting.service";
import { Router } from "@angular/router";
let MaintenanceModeConfigComponent = class MaintenanceModeConfigComponent {
    userInformationService;
    appControllerService;
    systemSettingService;
    router;
    changeDetectorRefs;
    formHeader = MaintenanceModeConfigConstants.FORM_HEADER;
    isSystemAdmin = false;
    maintenanceModeText = MaintenanceModeConfigConstants.MAINTENANCE_MODE_TEXT;
    maintenanceModeDescriptionText = MaintenanceModeConfigConstants.MAINTENANCE_MODE_DESCRIPTION_TEXT;
    sectionAvailabilityHeading = MaintenanceModeConfigConstants.SECTION_AVAILABILITY_HEADING;
    noticeText = MaintenanceModeConfigConstants.MAINTENANCE_MODE_NOTICE_TEXT;
    enableMaintenanceModeText = MaintenanceModeConfigConstants.ENABLE_BUTTON_TEXT;
    disableMaintenanceModeText = MaintenanceModeConfigConstants.DISABLE_BUTTON_TEXT;
    maintenanceModeActiveText = MaintenanceModeConfigConstants.MAINTENANCE_MODE_ACTIVE_TEXT;
    maintenanceModeDisabledText = MaintenanceModeConfigConstants.MAINTENANCE_MODE_DISABLED_TEXT;
    enabledLabelText = MaintenanceModeConfigConstants.ENABLED_LABEL_TEXT;
    disabledLabelText = MaintenanceModeConfigConstants.DISABLED_LABEL_TEXT;
    maintenanceModeValue = false;
    $userOrganisations;
    userOrganisations = [];
    authenticatedUser;
    authenticatedUserSubscription;
    maintenanceModeSubscription;
    constructor(userInformationService, appControllerService, systemSettingService, router, changeDetectorRefs) {
        this.userInformationService = userInformationService;
        this.appControllerService = appControllerService;
        this.systemSettingService = systemSettingService;
        this.router = router;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.maintenanceModeValue = this.systemSettingService.isMaintenanceModeEnabled();
        this.authenticatedUserSubscription = this.userInformationService.$authenticatedUser.subscribe(user => {
            this.isSystemAdmin = user.isSysAdmin;
            this.authenticatedUser = user;
            const organisations = user.organisations
                .sort((a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? -1 : 1));
            this.appControllerService.organisationsSubject.next(organisations);
            this.$userOrganisations = this.appControllerService.$organisationsSubject;
            this.userOrganisations = organisations;
        });
    }
    toggleMaintenanceMode(toggle) {
        this.maintenanceModeValue = toggle;
        this.maintenanceModeSubscription = this.systemSettingService.updateMaintenanceMode(toggle).subscribe({ next: (data) => {
                this.appControllerService.showMessage(toggle ? "Maintenance mode enabled" : "Maintenance mode disabled", AlertType.Success);
                if (toggle) {
                    this.router.navigateByUrl(`/${AppRoutingConstants.MAINTENANCE_PATH}`);
                }
                else {
                    this.router.navigateByUrl(DashboardRoutingConstants.MODULES_ROUTE);
                }
            }, error: (error) => {
                this.appControllerService.showMessage("Error enabling maintenance mode", AlertType.Error);
            } });
    }
    static ctorParameters = () => [
        { type: UserInformationService },
        { type: AppControllerService },
        { type: SystemSettingService },
        { type: Router },
        { type: ChangeDetectorRef }
    ];
};
MaintenanceModeConfigComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-maintenance-mode-config",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], MaintenanceModeConfigComponent);
export { MaintenanceModeConfigComponent };
